import { render, staticRenderFns } from "./CommunityGroups.vue?vue&type=template&id=196d96e2&scoped=true&"
import script from "./CommunityGroups.vue?vue&type=script&lang=ts&"
export * from "./CommunityGroups.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityGroups.vue?vue&type=style&index=0&id=196d96e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d96e2",
  null
  
)

export default component.exports